import NotificationCard from "./NotificationCard";

// Someone has been given Nodiant Coder (or a renewal, or more Macs). Shown only
// in the new-notifications popup, never the home feed. It opens their own
// licence page; the key itself is never stored on the notification.
export default function DesktopAppNotificationCard(props) {
    return (
        <NotificationCard
            {...props}
            type="desktopApp"
            destination="/desktop-app"
        />
    );
}
